import React from "react";
import {
  Container,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import PsychologyAltRoundedIcon from "@mui/icons-material/PsychologyAltRounded";
import TouchAppRoundedIcon from "@mui/icons-material/TouchAppRounded";
import "./SelectionContainer.css";

const options = [
  {
    type: "test",
    label: "Тестові завдання",
    description: "Питання з варіантами відповідей",
    icon: <PsychologyAltRoundedIcon />,
  },
  {
    type: "interactive",
    label: "Інтерактивні вправи",
    description: "Дропдауни, перетягування та практичні дії",
    icon: <TouchAppRoundedIcon />,
  },
  {
    type: "video",
    label: "Самостійна робота",
    description: "Відео та творчі завдання",
    icon: <OndemandVideoRoundedIcon />,
  },
];

const SelectionContainer = ({ onSelect }) => {
  return (
    <Container maxWidth="sm" className="module-type-page">
      <Paper className="module-type-panel" variant="outlined">
        <Typography variant="h5" component="h1">
          Оберіть тип завдань
        </Typography>
        <List disablePadding className="module-type-list">
          {options.map((option) => (
            <ListItemButton
              key={option.type}
              className="module-type-list__item"
              onClick={() => onSelect(option.type)}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.label} secondary={option.description} />
            </ListItemButton>
          ))}
        </List>
      </Paper>
    </Container>
  );
};

export default SelectionContainer;
